<fieldset class="bordas" style="width: auto; margin-top: 10px; margin-bottom: 10px">
    <div>
        <div fxFlex="100%">
            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboObjetivo_{{pinObjetivo}}" fxFlex="100" fxLayoutGap="20px" style="margin: 2px 0;">
                    <combo-objetivo
                            [showDisplayId]="false"
                            [obrigatorio]="true"
                            [selecionado]="objetivoAtividade.objetivo"
                            (valorChange)="onValorChangeObjetivo($event)">
                    </combo-objetivo>
                </div>
            </div>
        </div>
        <div fxFlex="10%" style="margin-top: 18px;margin-left: 26px;">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>